<template>
  <!-- Sidebar -->
  <div class="sidebar" id="sidebar">
    <div class="sidebar-inner">
      <perfect-scrollbar
        class="scroll-area"
        :settings="settings"
        @ps-scroll-y="scrollHanle"
      >
        <div id="sidebar-menu" class="sidebar-menu">
          <ul>
            <li class="menu-title">
              <span><i class="fontsize" data-feather="home"></i> Main</span>
            </li>
            <li>
              <router-link to="/admin/index"
                ><span>Dashboard</span></router-link
              >
            </li>
            <li>
              <router-link to="/admin/mentor"><span>Mentor</span></router-link>
            </li>
            <li>
              <router-link to="/admin/mentee"><span>Mentee</span></router-link>
            </li>
            <li>
              <router-link to="/admin/bookinglist"
                ><span>Booking List</span></router-link
              >
            </li>
            <li>
              <router-link to="/admin/categories"
                ><span>Categories</span></router-link
              >
            </li>
            <li>
              <router-link to="/admin/transactionslist"
                ><span>Transactions</span></router-link
              >
            </li>
            <li
              v-bind:class="{
                active:
                  currentPath == '/admin/localization-details' ||
                  currentPath == '/admin/social-settings' ||
                  currentPath == '/admin/seo-settings' ||
                  currentPath == '/admin/email-settings' ||
                  currentPath == '/admin/payment-settings' ||
                  currentPath == '/admin/settings' ||
                  currentPath == '/admin/others-settings' ||
                  currentPath == '/admin/social-links',
              }"
            >
              <router-link to="/admin/settings">
                <span>Settings</span></router-link
              >
            </li>

            <li class="submenu">
              <a href="javascript:;"
                ><span> Reports</span> <span class="menu-arrow"></span
              ></a>
              <ul style="display: none">
                <li>
                  <router-link to="/admin/invoices">Invoices List</router-link>
                </li>
                <li>
                  <router-link to="/admin/invoice-grid"
                    >Invoices Grid</router-link
                  >
                </li>
                <li>
                  <router-link to="/admin/add-invoice"
                    >Add Invoices</router-link
                  >
                </li>
                <li>
                  <router-link to="/admin/edit-invoice"
                    >Edit Invoices</router-link
                  >
                </li>
                <li>
                  <router-link to="/admin/view-invoice"
                    >Invoice Details</router-link
                  >
                </li>
                <li class="submenu">
                  <router-link
                    v-bind:class="{
                      active:
                        currentPath == '/admin/invoices-settings' ||
                        currentPath == '/admin/tax-settings' ||
                        currentPath == '/admin/bank-settings',
                    }"
                    to="/admin/invoices-settings"
                    >Invoice settings</router-link
                  >
                </li>
              </ul>
            </li>
            <li>
              <router-link to="/admin/invoice-items"
                ><span>Items</span></router-link
              >
            </li>
            <li class="menu-title">
              <span
                ><i class="fontsize" data-feather="file-text"></i> Pages</span
              >
            </li>
            <li>
              <router-link to="/admin/profile"
                ><span>My Profile</span></router-link
              >
            </li>
            <li class="submenu">
              <a href="javascript:;"><span>Blog</span> <span class="menu-arrow"></span></a>
              <ul style="display: none">
                <li><router-link to="/admin/blog"> Blog </router-link></li>
                <li>
                  <router-link to="/admin/blogdetails">
                    Blog Details
                  </router-link>
                </li>
                <li>
                  <router-link to="/admin/addblog"> Add Blog </router-link>
                </li>
                <li>
                  <router-link to="/admin/editblog"> Edit Blog </router-link>
                </li>
              </ul>
            </li>
            <li class="submenu">
              <a href="javascript:;"
                ><span> Authentication </span> <span class="menu-arrow"></span
              ></a>
              <ul style="display: none">
                <li><router-link to="/admin/login"> Login </router-link></li>
                <li>
                  <router-link to="/admin/register"> Register </router-link>
                </li>
                <li>
                  <router-link to="/admin/forgotpassword">
                    Forgot Password
                  </router-link>
                </li>
                <li>
                  <router-link to="/admin/lockscreen">
                    Lock Screen
                  </router-link>
                </li>
              </ul>
            </li>
            <li class="submenu">
              <a href="javascript:;"
                ><span> Error Pages </span> <span class="menu-arrow"></span
              ></a>
              <ul style="display: none">
                <li>
                  <router-link to="/admin/error404">404 Error </router-link>
                </li>
                <li>
                  <router-link to="/admin/error500">500 Error </router-link>
                </li>
              </ul>
            </li>
            <li>
              <router-link to="/admin/blankpage"
                ><span>Blank Page</span></router-link
              >
            </li>
            <li class="menu-title">
              <span
                ><i class="fontsize" data-feather="file"></i> UI Interface</span
              >
            </li>
            <li>
              <router-link to="/admin/components"
                ><span>Components</span></router-link
              >
            </li>
            <li class="submenu">
              <a href="javascript:;"
                ><span> Forms </span> <span class="menu-arrow"></span
              ></a>
              <ul style="display: none">
                <li>
                  <router-link to="/admin/formbasicinputs"
                    >Basic Inputs
                  </router-link>
                </li>
                <li>
                  <router-link to="/admin/forminputgroups"
                    >Input Groups
                  </router-link>
                </li>
                <li>
                  <router-link to="/admin/formhorizontal"
                    >Horizontal Form
                  </router-link>
                </li>
                <li>
                  <router-link to="/admin/formvertical">
                    Vertical Form
                  </router-link>
                </li>
                <li>
                  <router-link to="/admin/formmask"> Form Mask </router-link>
                </li>
                <li>
                  <router-link to="/admin/formvalidation">
                    Form Validation
                  </router-link>
                </li>
              </ul>
            </li>
            <li class="submenu">
              <a href="javascript:;"
                ><span> Tables </span> <span class="menu-arrow"></span
              ></a>
              <ul style="display: none">
                <li>
                  <router-link to="/admin/tablesbasic"
                    >Basic Tables
                  </router-link>
                </li>
                <li>
                  <router-link to="/admin/datatables">Data Table </router-link>
                </li>
              </ul>
            </li>
            <li class="submenu">
              <a href="javascript:void(0);"
                ><span>Multi Level</span> <span class="menu-arrow"></span
              ></a>
              <ul style="display: none">
                <li class="submenu">
                  <a href="javascript:void(0);">
                    <span>Level 1</span> <span class="menu-arrow"></span
                  ></a>
                  <ul style="display: none">
                    <li>
                      <a href="javascript:void(0);"><span>Level 2</span></a>
                    </li>
                    <li class="submenu">
                      <a href="javascript:void(0);">
                        <span> Level 2</span> <span class="menu-arrow"></span
                      ></a>
                      <ul style="display: none">
                        <li><a href="javascript:void(0);">Level 3</a></li>
                        <li><a href="javascript:void(0);">Level 3</a></li>
                      </ul>
                    </li>
                    <li>
                      <a href="javascript:void(0);"> <span>Level 2</span></a>
                    </li>
                  </ul>
                </li>
                <li>
                  <a href="javascript:void(0);"> <span>Level 1</span></a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </perfect-scrollbar>
    </div>
  </div>
  <!-- /Sidebar -->
</template>
<script>
import { PerfectScrollbar } from "vue3-perfect-scrollbar";
import "vue3-perfect-scrollbar/dist/vue3-perfect-scrollbar.css";
import { onMounted } from "vue";
import feather from "feather-icons";

export default {
  components: {
    PerfectScrollbar,
  },
  setup() {
    onMounted(() => {
      feather.replace();
      let $wrapper = $(".main-wrapper");

      $("#sidebar-menu a").on("click", function (e) {
        if ($(this).parent().hasClass("submenu")) {
          e.preventDefault();
        } else {
          $wrapper.removeClass("slide-nav");
          $(".sidebar-overlay").removeClass("opened");
          $("html").removeClass("menu-opened");
        }
        if (!$(this).hasClass("subdrop")) {
          $("ul", $(this).parents("ul:first")).slideUp(350);
          $("a", $(this).parents("ul:first")).removeClass("subdrop");
          $(this).next("ul").slideDown(350);
          $(this).addClass("subdrop");
        } else if ($(this).hasClass("subdrop")) {
          $(this).removeClass("subdrop");
          $(this).next("ul").slideUp(350);
        }
      });

      $("#sidebar-menu ul li.submenu a.active")
        .parents("li:last")
        .children("a:first")
        .addClass("active")
        .trigger("click");

      // Mobile menu sidebar overlay

      $("body").append('<div class="sidebar-overlay"></div>');
      $(document).on("click", "#mobile_btn", function () {
        $wrapper.toggleClass("slide-nav");
        $(".sidebar-overlay").toggleClass("opened");
        $("html").addClass("menu-opened");
        return false;
      });

      // Sidebar overlay

      $(".sidebar-overlay").on("click", function () {
        $wrapper.removeClass("slide-nav");
        $(".sidebar-overlay").removeClass("opened");
        $("html").removeClass("menu-opened");
      });
    });
  },
  computed: {
    currentPath() {
      return this.$route.name;
    },
  },
  data() {
    return {
      settings: {
        suppressScrollX: true,
      },
      activeClass: "active",
    };
    //  isactive : true
  },
  methods: {
    scrollHanle(evt) {},
  },
};
</script>
<style>
svg.feather.feather-home.fontsize {
  width: 20px;
  height: 19px;
}
svg.feather.feather-file-text.fontsize {
  width: 20px;
  height: 19px;
}
svg.feather.feather-file.fontsize {
  width: 20px;
  height: 19px;
}

.scroll-area {
  position: relative;
  margin: auto;
  height: calc(100vh - 60px);
  background-color: transparent !important;
}
.sidebar-menu ul li a.active {
  background-color: transparent;
  color: #1879cd;
}
.sidebar-menu ul ul a.active {
  color: #1879cd;
  text-decoration: underline;
  background-color: unset;
}
</style>
